import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { authClient } from "@/auth";

export const Route = createFileRoute("/auth")({
	beforeLoad: async () => {
		const { data: session } = await authClient.getSession();
		if (session) {
			throw redirect({ to: "/dashboard" });
		}
	},
	component: Outlet,
});
